import { render } from "./App.vue?vue&type=template&id=144ac37f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=144ac37f&lang=css"
script.render = render

export default script